import { PkCardTypes } from 'src/pkScripts/Helpers/PkCardTypes';
import { TileExtension, ITileLocalExtensionContext, disableWithCollapsing} from 'tessa/ui/tiles';
import { CdCardTypes } from '../Helpers/CdCardTypes';


export class CdDisableCreateFileFromTemplateTileExtension extends TileExtension {

  public initializingLocal(context: ITileLocalExtensionContext) {
    const panel = context.workspace.leftPanel;
    const editor = panel.context.cardEditor;
    let typeid;
    if (editor == null || editor.cardModel == null ||
      editor.cardModel.cardType.id == null) {
      return;
    }
    typeid = editor.cardModel.cardType.id;
    if (typeid != null &&
        (CdCardTypes.CopyTileCardTypes.indexOf(typeid) > -1 ||
          PkCardTypes.CopyTileCardTypes.indexOf(typeid) > -1)) {
      const createFileFromTemplateTile = panel.tryGetTile('CreateFileFromTemplate');
      if (createFileFromTemplateTile != null) {
        disableWithCollapsing(createFileFromTemplateTile);
      }
    }
  }

}